import * as  TYPE from "./actionTypes"

export const client = (note_cnt, token) => {
    return {
        type: TYPE.LOGIN,
        note_cnt: note_cnt,
        menu: 'tournament',
        token: token,
    }
}

export const newToken = (token) => {
    return {
        type: TYPE.NEW_TOKEN,
        new_token: token
    }
}

export const noteCount = (cnt) => {
    return {
        type: TYPE.NOTE_COUNT,
        note_cnt: cnt
    }
}

export const menu = (choice) => {
    return {
        type: TYPE.MENU,
        menu: choice
    }
}
